const MILES_CONVERTER = 1.609344;
const NAUTICAL_MILES_CONVERTER = 1.852;

const calculateMiles = (km: number): number => km * MILES_CONVERTER;

export const calculateNauticalMiles = (km: number): number => km * NAUTICAL_MILES_CONVERTER;

export default calculateMiles;
